<template>
  <!-- 质量看板 -->
  <div class="qualityBoard">
    <!-- 头部 -->
    <div class="head">
      <!-- 问题类型选择 -->
      <div class="questionType">
        <el-radio-group v-model="questionType" size="small" @change="search">
          <el-radio-button label="3">2D</el-radio-button>
          <el-radio-button label="1">3D</el-radio-button>
          <el-radio-button label="0">文件</el-radio-button>
        </el-radio-group>
      </div>

      <!-- 项目区域 -->
      <div class="projectRegion">
        <span>项目区域：</span>
        <div class="regions">
          <el-button type="primary" size="mini" :plain="region !== ''" @click="region = ''">全部</el-button>
          <el-button v-for="item in cityRegions" :key="item.code" type="primary" size="mini" :plain="region !== item.code" @click="region = item.code">
            {{ item.name }}
          </el-button>

          <div v-if="!regionOpen && prjAreaList.length > 6" class="Btn" @click="regionOpen = true">
            <span>展开</span>
            <i class="el-icon-arrow-down"></i>
          </div>
          <div v-if="regionOpen" class="Btn" @click="regionOpen = false">
            <span>收起</span>
            <i class="el-icon-arrow-up"></i>
          </div>
        </div>
      </div>
      <!-- 项目时间 -->
      <div class="projectDate">
        <span>项目时间：</span>
        <el-date-picker v-model="projectDate" :picker-options="pickerOptions" type="daterange" size="small" align="right"
          start-placeholder="开始月份" range-separator="至" end-placeholder="结束月份" unlink-panels>
        </el-date-picker>

        <el-button size="small" style="margin-left: 20px;" plain @click="projectDate = ''">重置</el-button>
        <el-button size="small" type="primary" @click="search">查询</el-button>
      </div>

      <!-- 标签行 -->
      <div class="labels">
        <el-tag type="info" :style="`background: url('${label_blue}');`" effect="plain">
          <div class="text_up">{{ labelsData.prjNum }}</div>
          <div class="text_down">项目总数</div>
        </el-tag>
        <el-tag type="info" :style="`background: url('${label_green}');`" effect="plain">
          <div class="text_up">{{ labelsData.modifiedNum }}</div>
          <div class="text_down">已修改问题数</div>
        </el-tag>
        <el-tag type="info" :style="`background: url('${label_pink}');`" effect="plain">
          <div class="text_up">{{ labelsData.reviewNum }}</div>
          <div class="text_down">已复核问题数</div>
        </el-tag>
        <el-tag type="info" :style="`background: url('${label_orange}');`" effect="plain">
          <div class="text_up">{{ labelsData.internalPeopleNum }}</div>
          <div class="text_down">内部参与人数</div>
        </el-tag>
        <el-tag type="info" :style="`background: url('${label_blue}');`" effect="plain">
          <div class="text_up">{{ labelsData.externalPeopleNum }}</div>
          <div class="text_down">外部参与人数</div>
        </el-tag>
        <el-tag type="info" :style="`background: url('${label_pink}');`" effect="plain">
          <div class="text_up">{{ labelsData.totalNum }}</div>
          <div class="text_down">项目总问题</div>
        </el-tag>
        <el-tag type="info" :style="`background: url('${label_green}');`" effect="plain">
          <div class="text_up">{{ labelsData.modificationRate }}</div>
          <div class="text_down">问题修改率</div>
        </el-tag>
        <el-tag type="info" :style="`background: url('${label_orange}');`" effect="plain">
          <div class="text_up">{{ labelsData.reviewRate }}</div>
          <div class="text_down">问题复核率</div>
        </el-tag>
        <el-tag type="info" :style="`background: url('${label_blue}');`" effect="plain">
          <div class="text_up">{{ labelsData.internalAverage }}</div>
          <div class="text_down">内部人均问题</div>
        </el-tag>
        <el-tag type="info" :style="`background: url('${label_pink}');margin-right: 0`" effect="plain">
          <div class="text_up">{{ labelsData.externalAverage }}</div>
          <div class="text_down">外部人均问题</div>
        </el-tag>
      </div>
    </div>

    <!-- 问题统计表 -->
    <div class="chart">
      <problemStatistics ref="allQueChart" :question-type="questionType" :region="region" :start-date="startDate" :end-date="endDate"> </problemStatistics>
    </div>
    <!-- 校对问题统计表 -->
    <div class="chart">
      <checkQuestion ref="checkQueChart" :question-type="questionType" :region="region" :start-date="startDate" :end-date="endDate"> </checkQuestion>
    </div>
    <!-- 审核问题统计表 -->
    <div class="chart">
      <examineQuestion ref="examineQueChart" :question-type="questionType" :region="region" :start-date="startDate" :end-date="endDate"></examineQuestion>
    </div>
    <!-- 审定问题统计表 -->
    <div class="chart">
      <approveQuestion ref="approveQueChart" :question-type="questionType" :region="region" :start-date="startDate" :end-date="endDate"></approveQuestion>
    </div>
    <!-- 其他问题统计表 -->
    <div class="chart" style="margin-bottom: 0">
      <otherQuestion ref="otherQueChart" :question-type="questionType" :region="region" :start-date="startDate" :end-date="endDate"> </otherQuestion>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import dataBoardService from "@/CommonDP/service/dataBoard-service.js";
import Cookies from "js-cookie";
import { storage } from "@/CommonDP/utils";
import moment from "moment";

import problemStatistics from "./qualityComponents/problemStatistics.vue";
import checkQuestion from "./qualityComponents/checkQuestion.vue";
import examineQuestion from "./qualityComponents/examineQuestion.vue";
import approveQuestion from "./qualityComponents/approveQuestion.vue";
import otherQuestion from "./qualityComponents/otherQuestion.vue";

export default {
  components: {
    problemStatistics,
    checkQuestion,
    examineQuestion,
    approveQuestion,
    otherQuestion
  },
  data() {
    return {
      label_blue: require("@/CommonDP/assets/application/enterpriseBoard/label_blue.png"), // 标签行背景图
      label_green: require("@/CommonDP/assets/application/enterpriseBoard/label_green.png"),
      label_pink: require("@/CommonDP/assets/application/enterpriseBoard/label_pink.png"),
      label_orange: require("@/CommonDP/assets/application/enterpriseBoard/label_orange.png"),

      questionType: "3", // 当前问题类型：	2D问题，3D问题，文件问题
      labelsData: {
        externalAverage: 0, // 外部人均问题数
        externalPeopleNum: 0, // 	外部参与人数
        internalAverage: 0, // 	内部人均问题数
        internalPeopleNum: 0, // 	内部参与人数
        modificationRate: "", // 	问题修改率
        modifiedNum: 0, // 已修改问题数
        prjNum: 0, // 项目数量
        reviewNum: 0, // 	已复核问题数
        reviewRate: "", // 		问题复核率
        totalNum: 0 // 		项目总问题数
      },

      prjAreaList: [], // 项目区域数据
      region: "", // 项目区域
      regionOpen: false, // 项目区域展开
      projectDate: "", // 选择项目时间

      pickerOptions: {
        // 日期选择快捷键
        shortcuts: [
          {
            text: "近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      }
    };
  },
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId
    }),

    // 开始时间
    startDate() {
      if (this.projectDate && this.projectDate.length > 0) {
        return moment(this.projectDate[0]).format("YYYY-MM-DD") + " 00:00:00";
      } else {
        return "";
      }
    },
    // 结束时间
    endDate() {
      if (this.projectDate && this.projectDate.length > 1) {
        return moment(this.projectDate[1]).format("YYYY-MM-DD") + " 00:00:00";
      } else {
        return "";
      }
    },

    // 城市区域
    cityRegions() {
      let provinces = this.prjAreaList;
      provinces = provinces.filter((item) => item.name);
      provinces = provinces.map((item) => {
        const city = { ...item };
        let name = item.name;
        name = name.replace("市", "");
        city.name = name;
        return city;
      });
      if (!this.regionOpen && this.prjAreaList.length > 6) {
        return provinces.slice(0, 6);
      } else {
        return provinces;
      }
    }
  },
  watch: {
    region() {
      this.$nextTick(() => {
        this.search();
      });
    }
  },
  mounted() {
    this.getTopInfo();
    this.getPrjAreaList();
  },
  mounted() {
    this.getTopInfo();
    this.getPrjAreaList();
  },
  methods: {
    // 质量看板-顶部数据
    async getTopInfo() {
      const params = {
        category: this.questionType, // 	3=2d问题，1=3d问题，0=文件问题
        enterpriseId: this.enterpriseId,
        cityCode: this.region || "", // 	城市编码
        startDate: this.startDate, // 开始时间
        endDate: this.endDate // 结束时间
      };
      const res = await dataBoardService.getTopInfo(params);
      this.labelsData = res.data;
    },

    // 查询项目区域+区域内项目数量
    async getPrjAreaList() {
      const params = {
        enterpriseId: this.enterpriseId
      };
      const res = await dataBoardService.getPrjAreaList(params);
      this.prjAreaList = res.data;
    },

    // 查询
    search() {
      this.getTopInfo();
      this.$refs.allQueChart.setOption();
      this.$refs.checkQueChart.setOption();
      this.$refs.examineQueChart.setOption();
      this.$refs.approveQueChart.setOption();
      this.$refs.otherQueChart.setOption();
    },

    // 导出PPT
    async exportPPT() {
      const slideList = [
        this.$refs.allQueChart.slideData("问题总计"),
        this.$refs.checkQueChart.slideData("校对问题统计"),
        this.$refs.examineQueChart.slideData("审核问题统计"),
        this.$refs.approveQueChart.slideData("审定问题统计"),
        this.$refs.otherQueChart.slideData("其他问题统计")
      ]; // 图表数据

      const params = {
        dashboard: 2, // 质量看板固定 2
        condition: {
          enterpriseId: this.enterpriseId,
          category: this.questionType,
          cityCode: this.region,
          startDate: this.startDate,
          endDate: this.endDate
        }, // 顶部查询条件
        slideList
      };
      const res = await dataBoardService.exportPPT(params);
      const fileName = "质量看板.pptx";
      if ("msSaveOrOpenBlob" in navigator) {
        window.navigator.msSaveOrOpenBlob(res, fileName);
        return;
      } else {
        const link = document.createElement("a");
        const blob = res;
        link.style.display = "none";
        link.href = URL.createObjectURL(blob);
        link.setAttribute("download", decodeURI(fileName));
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    },
    // 导出excel
    async exportExcel() {
      const conditionArray = [
        this.$refs.allQueChart.conditionData("t180000000008622"),
        this.$refs.checkQueChart.conditionData("t180000000008621"),
        this.$refs.examineQueChart.conditionData("t180000000008620"),
        this.$refs.approveQueChart.conditionData("t180000000008619"),
        this.$refs.otherQueChart.conditionData("")
      ]; // 图表数据
      const params = {
        dashboard: 2, // 质量看板固定 2
        condition: {
          enterpriseId: this.enterpriseId,
          category: this.questionType,
          cityCode: this.region,
          startDate: this.startDate,
          endDate: this.endDate
        }, // 顶部查询条件
        conditionArray
      };
      const res = await dataBoardService.exportExcel(params);
      const fileName = "质量看板.xlsx";
      if ("msSaveOrOpenBlob" in navigator) {
        window.navigator.msSaveOrOpenBlob(res, fileName);
        return;
      } else {
        const link = document.createElement("a");
        const blob = res;
        link.style.display = "none";
        link.href = URL.createObjectURL(blob);
        link.setAttribute("download", decodeURI(fileName));
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.qualityBoard {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  .head {
    width: 100%;
    padding: var(--big-space);
    border-radius: 0 0 4px 4px;
    background-color: white;
    margin-bottom: var(--middle-space);

    .questionType {
      width: 100%;
      padding: 0 0 var(--middle-space);
    }

    .labels {
      width: 100%;
      padding: var(--middle-space) 0;
      display: flex;
      align-items: center;

      .el-tag {
        width: 180px;
        height: 100px;
        padding: 20px 0;
        border: none;
        margin-right: 10px;
        background-repeat: no-repeat;
        background-size: cover;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        align-items: center;

        .text_up {
          font-family: "GeoSlab703 Md BT";
          font-weight: 400;
          font-size: 30px;
          color: #ffffff;
          white-space: nowrap;
        }

        .text_down {
          font-family: "PingFang SC";
          font-weight: 400;
          font-size: 16px;
          line-height: 22px;
          color: #ffffff;
          white-space: nowrap;
        }
      }
    }

    .projectRegion {
      width: 100%;
      display: flex;

      span {
        line-height: 40px;
        font-size: 14px;
        font-weight: 400;
        font-family: "Microsoft YaHei UI";
        color: var(--key-color);
      }

      .regions {
        width: calc(100% - 80px);
        display: flex;
        align-items: center;
        flex-flow: wrap;

        .el-button {
          padding: 7px 18px;
          border: none;
          margin: 5px 0;
          font-family: "PingFang SC";
          font-weight: 400;
          font-size: 14px;
        }

        /deep/ .el-button--primary.is-plain {
          background: #eef3fd !important;
          color: #4777e7 !important;
        }

        .Btn {
          margin-left: 20px;
          white-space: nowrap;
          cursor: pointer;

          display: flex;
          align-items: center;

          span {
            color: var(--theme-color);
            font-family: "PingFang SC";
            font-weight: 400;
            font-size: 14px;
            line-height: 28px;
          }

          i {
            padding: 0 4px;
            color: var(--theme-color);
          }
        }
      }
    }

    .projectDate {
      width: 100%;
      padding: var(--middle-space) 0;
      display: flex;
      align-items: center;

      span {
        font-family: "Microsoft YaHei UI";
        font-weight: 400;
        font-size: 14px;
        line-height: 28px;
        color: var(--key-color);
        white-space: nowrap;
      }
    }
  }

  .chart {
    width: 100%;
    margin-bottom: var(--middle-space);
  }
}

/deep/.el-range-separator {
  width: max-content;
}
</style>
